import type { IMetadata } from '@adloid-technologies/discover-sdk';

export const metadata: IMetadata = {
  models: {
    Traverse: {
      id: 'Traverse',
      lightingIdentifier: {
        interior: 'dome',
        exterior: 'dome',
      },
      postProcessingIdentifier: {
        interior: 'dome',
        exterior: 'dome',
      },
      backgroundIdentifer: 'dome',
      variants: {
        z71: {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5779',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5778',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5777',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'variants_parts',
              sku: '5773',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'alloy',
              sku: '5781',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '7083',
              projectId: '59',
              position: [0, 0, 0],
              maxResolution: {
                ios: '2K',
                android: '4K',
              },
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
        lt: {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5779',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5761',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5770',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'variants_parts',
              sku: '5764',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '7083',
              projectId: '59',
              position: [0, 0, 0],
              maxResolution: {
                ios: '2K',
                android: '4K',
              },
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
        'lt-d5tbgkkfd7k97': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5779',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5761',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5770',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'variants_parts',
              sku: '5775',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '7083',
              projectId: '59',
              position: [0, 0, 0],
              maxResolution: {
                ios: '2K',
                android: '4K',
              },
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
      },
      backgrounds: {
        g0ZA968_RpUd: {
          isDefault: true,
          sku: '7083',
          project: '59',
        },
        g0ZA968_RpUe: {
          isDefault: false,
          sku: '7084',
          project: '59',
        },
      },
      ambientLighting: {
        ambientColors: '',
        ambientLightings: {},
        relevantVariants: [],
      },
      colors: {
        interior: {
          tardm9hwgcy55: {
            sku: '5777',
            project: '59',
            relevantVariants: ['z71'],
            notCompatibleExteriorColors: [],
          },
          '6zg8oyzi80j9': {
            sku: '5771',
            project: '59',
            relevantVariants: ['lt'],
            notCompatibleExteriorColors: [],
            accessoriesToReload: ['myq5eupjxhja', 'lcp3flb8g8m6'],
          },
          ojenkj2t5p54: {
            sku: '5785',
            project: '59',
            relevantVariants: ['lt'],
            notCompatibleExteriorColors: [],
            accessoriesToReload: ['myq5eupjxhja', 'lcp3flb8g8m6'],
          },
          tarm9hwgcy55: {
            sku: '5771',
            project: '59',
            relevantVariants: ['lt-d5tbgkkfd7k97'],
            notCompatibleExteriorColors: [],
            accessoriesToReload: ['xnc1alw2alfa', 'mnc1alw2alfa'],
          },
          taqrm9hwgcy56: {
            sku: '5770',
            project: '59',
            relevantVariants: ['lt'],
            notCompatibleExteriorColors: [],
            accessoriesToReload: ['myq5eupjxhja', 'lcp3flb8g8m6'],
          },
          taqrm9hwgcy55: {
            sku: '5770',
            project: '59',
            relevantVariants: ['lt-d5tbgkkfd7k97'],
            notCompatibleExteriorColors: [],
            accessoriesToReload: ['xnc1alw2alfa', 'mnc1alw2alfa'],
          },
          tarm9hewgcy55: {
            sku: '5785',
            project: '59',
            relevantVariants: ['lt-d5tbgkkfd7k97'],
            notCompatibleExteriorColors: [],
            accessoriesToReload: ['xnc1alw2alfa', 'mnc1alw2alfa'],
          },
        },
        exterior: {
          '5c8ep1iwg2jn': {
            sku: '5761',
            project: '59',
            relevantVariants: ['z71'],
          },
          sn7yhhtw36la: {
            sku: '5783',
            project: '59',
            relevantVariants: ['z71'],
          },
          '0c7b33ow746eu': {
            sku: '5780',
            project: '59',
            relevantVariants: ['z71'],
          },
          fa1gr6h4tgwqj: {
            sku: '5776',
            project: '59',
            relevantVariants: ['z71'],
          },
          '8gq4rd16o5mdp': {
            sku: '5778',
            project: '59',
            relevantVariants: ['z71'],
          },
          nwlfddrqlbg2: {
            sku: '5788',
            project: '59',
            relevantVariants: ['z71'],
          },
          mp3svcxjkf6n: {
            sku: '5761',
            project: '59',
            relevantVariants: ['lt'],
          },
          '8udilr5nuqyd': {
            sku: '5783',
            project: '59',
            relevantVariants: ['lt'],
          },
          '0ua46njowdyw': {
            sku: '5780',
            project: '59',
            relevantVariants: ['lt'],
          },
          '1a89yotoix4m': {
            sku: '5776',
            project: '59',
            relevantVariants: ['lt'],
          },
          y115ku95mdlo: {
            sku: '5778',
            project: '59',
            relevantVariants: ['lt'],
          },
          '03qc7azao6jc': {
            sku: '5782',
            project: '59',
            relevantVariants: ['lt'],
          },
          '5wc8ep1iwg2jn': {
            sku: '5761',
            project: '59',
            relevantVariants: ['lt-d5tbgkkfd7k97'],
          },
          sn7yhhtsw36la: {
            sku: '5783',
            project: '59',
            relevantVariants: ['lt-d5tbgkkfd7k97'],
          },
          '0c7b3ow746eu': {
            sku: '5780',
            project: '59',
            relevantVariants: ['lt-d5tbgkkfd7k97'],
          },
          fa1g6h4tgwqj: {
            sku: '5776',
            project: '59',
            relevantVariants: ['lt-d5tbgkkfd7k97'],
          },
          '8gq4d16o5mdp': {
            sku: '5778',
            project: '59',
            relevantVariants: ['lt-d5tbgkkfd7k97'],
          },
          nwljddrqlbg2: {
            sku: '5782',
            project: '59',
            relevantVariants: ['lt-d5tbgkkfd7k97'],
          },
        },
      },
      features: {
        qlpdcncqd64b7: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['z71'],
          messages: [
            // {
            //   message: 'SHADER_Front fascia',
            //   identifiers: ['common_exterior'],
            //   waitForFulfill: false,
            //   cascade: false,
            // },
            {
              message: 'Front fascia',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        kh1xk6vtsachr: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['z71'],
          messages: [
            {
              message: 'SHADER_Skid plate and Red Tow hooks',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Skid plate and Red Tow hooks',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '2uhwaenqtv8gj': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['z71'],
          messages: [
            {
              message: 'SHADER_18Inch Alloy w Terrain Tire',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '18Inch Alloy w Terrain Tire',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '1slkxzq7syxvp': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['z71'],
          messages: [
            {
              message: 'SHADER_ORVM',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'ORVM',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            '82lc5jd2ekej': {
              add: false,
              snapToLastFrame: true,
            },
          },
        },
        kbnsv5f4ez323: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['z71'],
          messages: [
            // {
            //   message: 'SHADER_Black Bowtie and Accents',
            //   identifiers: ['common_exterior'],
            //   waitForFulfill: false,
            //   cascade: false,
            // },
            {
              message: 'Black Bowtie and Accents',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        okpcdbfyxu7lo: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['z71'],
          messages: [
            {
              message: 'SHADER_Z71 Badging and Embroidery',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Z71 Badging and Embroidery',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        okpcdmfyxu7lo: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['z71'],
          messages: [
            {
              message: 'SHADER_Roof Rails',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Roof Rails',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        okpycdfyxu7lo: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['z71'],
          messages: [
            // {
            //   message: 'SHADER_Autosense Power Liftgate',
            //   identifiers: ['common_exterior'],
            //   waitForFulfill: false,
            //   cascade: false,
            // },
            {
              message: 'Autosense Power Liftgate',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        whq2pdteldd7b: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['z71'],
          messages: [
            {
              message: 'SHADER_17.7 Inch Info Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '17.7 Inch Info Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        sulp9ougcljsd: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['z71'],
          messages: [
            {
              message: 'SHADER_11 inch Driver Info Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '11 inch Driver Info Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '14ogjjvbzhg1q': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['z71'],
          messages: [
            {
              message: 'SHADER_Wireless Charging',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Wireless Charging',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '1i87rhvwcyk2a': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['z71'],
          messages: [
            {
              message: 'SHADER_Selectable Drive Mode',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Selectable Drive Mode',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        xje8uk6tk6c08: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['z71'],
          messages: [
            {
              message: 'Adaptive Cruise Control',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Adaptive Cruise Control',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        t8ynwcphoj7u: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['lt'],
          messages: [
            // {
            //   message: 'SHADER_Luxury Chrome Fascia',
            //   identifiers: ['common_exterior'],
            //   waitForFulfill: false,
            //   cascade: false,
            // },
            {
              message: 'Luxury Chrome Fascia',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '067rg7evcxb1': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'SHADER_18Inch Alloy',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '18Inch Alloy',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        guhx4v57069b: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'SHADER_LED Headlamp',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'LED Headlamp',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        xeer2id8g101: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          messages: [
            {
              message: 'Trunk Space',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [
            // {
            //   message: 'TAILGATE_CLOSE',
            //   identifiers: [
            //     'exterior-color',
            //     'common_exterior',
            //     'common_interior',
            //     'interior-color',
            //     'variants_parts',
            //   ],
            //   waitForFulfill: false,
            //   cascade: true,
            // },
          ],
          affectedInteractionOnApply: {
            dfgiszto8mb3: {
              add: true,
              snapToLastFrame: false,
              persistOnFeatureChange: false,
              withoutCamera: true,
            },
          },
        },
        j0uvwd5nthk7: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'SHADER_17.7 Inch Info Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '17.7 Inch Info Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        z3srxz0nqyp8: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'SHADER_11 inch Driver Info Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '11 inch Driver Info Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        c5iuh84l2wuy: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'SHADER_Wireless Charging',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Wireless Charging',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        x1i79a28r096: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'Heated Front Seats',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        gan512rek2tm: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'USB port',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_USB port',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        qlpcncqd64b7: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          messages: [
            // {
            //   message: 'SHADER_Luxury Chrome Fascia',
            //   identifiers: ['common_exterior'],
            //   waitForFulfill: false,
            //   cascade: false,
            // },
            {
              message: 'Luxury Chrome Fascia',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '2uhaenqtv8gj': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          messages: [
            {
              message: 'SHADER_18Inch Alloy',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '18Inch Alloy',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '1slkxz7syxvp': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          messages: [
            {
              message: 'SHADER_LED Headlamp',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'LED Headlamp',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        wh2pdteldd7b: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          messages: [
            {
              message: 'SHADER_17.7 Inch Info Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '17.7 Inch Info Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        sulp9ugcljsd: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          messages: [
            {
              message: 'SHADER_11 inch Driver Info Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '11 inch Driver Info Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '14ojjvbzhg1q': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          messages: [
            {
              message: 'SHADER_Wireless Charging',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Wireless Charging',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '1i87rvwcyk2a': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          messages: [
            {
              message: 'Heated Front Seats',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        xje8k6tk6c08: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          messages: [
            {
              message: 'USB port',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_USB port',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
      },
      accessories: {
        w9hpezuxt0zw: {
          view: 'exterior',
          groupId: 'Accessories',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Variant_Parts_Z71_AWD',
              identifiers: ['exterior-color'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['z71'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '69tpimc80pm8d': {
          view: 'exterior',
          groupId: 'Roof',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_Sunroof',
              identifiers: ['exterior-color'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['z71'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '5cq7w508taix': {
          view: 'exterior',
          groupId: 'Roof',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Optional_Sunroof',
              identifiers: ['exterior-color'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['z71'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        u20mu3d5j71vd: {
          view: 'exterior',
          groupId: 'Roof',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '18 inch High Gloss Black Machined face',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['z71'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        ph2ilwyfnyoz: {
          view: 'exterior',
          groupId: 'Accessories',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Variant_Parts_LT_AWD',
              identifiers: ['exterior-color'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '58463v6cha9h': {
          view: 'exterior',
          groupId: 'Roof',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_Sunroof',
              identifiers: ['exterior-color'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        bz1v4t37607s: {
          view: 'exterior',
          groupId: 'Roof',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Optional_Sunroof',
              identifiers: ['exterior-color'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        u1947q9mlw5i: {
          view: 'exterior',
          groupId: 'Accessories-Midnight',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_Midnight_Edition',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        dnc6qvmfvihz: {
          view: 'exterior',
          groupId: 'Accessories-Midnight',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_Midnight_Edition',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        sisoevvyzbkx: {
          view: 'exterior',
          groupId: 'Wheels',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: '18 Inch_Grazen_Metallic_aluminum',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        wegeh5s0vwal: {
          view: 'exterior',
          groupId: 'Wheels',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '20 inch_High_Gloss_Black_painted_Aluminium',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        arzp4zbywxqd: {
          view: 'exterior',
          groupId: 'Wheels',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '20 inch_Carbon_Flash_Metalic',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        // Seat groups are per trim (lt-seats / lt-fwd-seats): the SDK resolves a
        // group's default model-wide, so a shared 'Seats' group made removing LT
        // FWD's Bench Seats restore LT AWD's captain seats - not on the FWD
        // colours' accessoriesToReload list, so the 2nd row stopped recolouring.
        myq5eupjxhja: {
          view: 'exterior',
          groupId: 'lt-seats',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Default_Captain_Seats_Jet_Black',
              identifiers: ['common_exterior'],
              condition: '(5771) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
            {
              message: 'Default_Captain_Seats_Jet Black/Gideon',
              identifiers: ['common_exterior'],
              condition: '(5770) is (interior-color)',
              isDefault: true,
              isStop: false,
            },
            {
              message: 'Default_Captain_Seats_Jet Black Evotex',
              identifiers: ['common_exterior'],
              condition: '(5785) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        lcp3flb8g8m6: {
          // Bench seats are an interior option - 'interior' so applying them from
          // the Interior tab keeps the camera inside instead of flipping to EXT.
          view: 'interior',
          groupId: 'lt-seats',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Optional_Bench_Seats_Jet_Black',
              identifiers: ['common_exterior'],
              condition: '(5771) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
            {
              message: 'Optional_Bench_Seats_Jet Black/Gideon',
              identifiers: ['common_exterior'],
              condition: '(5770) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
            {
              message: 'Optional_Bench_Seats_Jet Black Evotex',
              identifiers: ['common_exterior'],
              condition: '(5785) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        z9ajh37fas0j: {
          view: 'exterior',
          groupId: 'Accessories',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Variant_Parts_LT_FWD',
              identifiers: ['exterior-color'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        r4764rbf9ulm: {
          view: 'exterior',
          groupId: 'Roof',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_Sunroof',
              identifiers: ['exterior-color'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        a32j9gyvb1sn: {
          view: 'exterior',
          groupId: 'Roof',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Optional_Sunroof',
              identifiers: ['exterior-color'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        i4hkqruarfkl: {
          view: 'exterior',
          groupId: 'Accessories-Midnight',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_Midnight_Edition',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        ox0nj2j5ceyj: {
          view: 'exterior',
          groupId: 'Accessories-Midnight',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_Midnight_Edition',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '3nc1olw2alfk': {
          view: 'exterior',
          groupId: 'Wheels',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: '18 Inch_Grazen_Metallic_aluminum',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '3nc1olw2alfa': {
          view: 'exterior',
          groupId: 'Wheels',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '20 inch_High_Gloss_Black_painted_Aluminium',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        anc1alw2alfa: {
          view: 'exterior',
          groupId: 'Wheels',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '20 inch_Carbon_Flash_Metalic',
              identifiers: ['common_exterior'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        xnc1alw2alfa: {
          view: 'exterior',
          groupId: 'lt-fwd-seats',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Default_Captain_Seats_Jet_Black',
              identifiers: ['common_exterior'],
              condition: '(5771) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
            {
              message: 'Default_Captain_Seats_Jet Black/Gideon',
              identifiers: ['common_exterior'],
              condition: '(5770) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
            {
              message: 'Default_Captain_Seats_Jet Black Evotex',
              identifiers: ['common_exterior'],
              condition: '(5785) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        mnc1alw2alfa: {
          // Bench seats are an interior option - 'interior' so applying them from
          // the Interior tab keeps the camera inside instead of flipping to EXT.
          view: 'interior',
          groupId: 'lt-fwd-seats',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Optional_Bench_Seats_Jet_Black',
              identifiers: ['common_exterior'],
              condition: '(5771) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
            {
              message: 'Optional_Bench_Seats_Jet Black/Gideon',
              identifiers: ['common_exterior'],
              condition: '(5770) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
            {
              message: 'Optional_Bench_Seats_Jet Black Evotex',
              identifiers: ['common_exterior'],
              condition: '(5785) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt-d5tbgkkfd7k97'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
      },
      packages: {
        'x7vtyrufcgr0-lt': {
          groupId: 'Packages',
          accessoryIds: ['dnc6qvmfvihz', 'wegeh5s0vwal'],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: ['lt'],
        },
        'x7vtyrurfcgr0-lt': {
          groupId: 'Packages',
          accessoryIds: ['arzp4zbywxqd', 'bz1v4t37607s'],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: ['lt'],
        },
        'x7vtyruofcgr0-lt-d5tbgkkfd7k97': {
          groupId: 'Packages',
          accessoryIds: ['ox0nj2j5ceyj', '3nc1olw2alfa'],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: ['lt-d5tbgkkfd7k97'],
        },
        'x7vtyrufcgr0t-lt-d5tbgkkfd7k97': {
          groupId: 'Packages',
          accessoryIds: ['anc1alw2alfa', 'a32j9gyvb1sn'],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: ['lt-d5tbgkkfd7k97'],
        },
      },
      interactions: {
        '82lc5jd2ekej': {
          type: 'basic',
          view: ['exterior', 'interior'],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: ['z71', 'lt', 'lt-d5tbgkkfd7k97'],
        },
        dfgiszto8mb3: {
          type: 'basic',
          view: ['exterior'],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: ['z71', 'lt', 'lt-d5tbgkkfd7k97'],
        },
        auuqx6b61pgx: {
          type: 'basic',
          view: ['exterior'],
          startMessages: [
            {
              message: 'SUNROOF_SHADE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_SHADE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 4.7123,
                beta: 1.6118,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: ['z71', 'lt', 'lt-d5tbgkkfd7k97'],
          availableFor: {
            accessories: ['5cq7w508taix', 'bz1v4t37607s', 'a32j9gyvb1sn'],
          },
        },
        frif2u36is65: {
          type: 'basic-light',
          view: ['exterior'],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: ['z71', 'lt', 'lt-d5tbgkkfd7k97'],
        },
        bpgyvbbuz3x4: {
          type: 'basic-light',
          view: ['exterior'],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: ['z71', 'lt', 'lt-d5tbgkkfd7k97'],
        },
        wjs0s4nuo7zq: {
          type: 'basic-light',
          view: ['exterior'],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 5,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: ['z71', 'lt', 'lt-d5tbgkkfd7k97'],
        },
      },
      hotspots: {
        exteriorCamera: {
          type: 'exterior',
          messages: {
            fov: 0.8,
            alpha: 2.02,
            beta: 1.47,
            radius: 5.7,
            upperRadiusLimit: 6.7,
            lowerRadiusLimit: 3.2,
            lowerBetaLimit: 0.1,
            upperBetaLimit: 1.6,
            lowerAlphaLimit: null,
            upperAlphaLimit: null,
            target: {
              x: 0,
              y: 0.65,
              z: 0,
            },
            isFovZoomModeOn: false,
          },
        },
        interiorCamera: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA',
            identifiers: ['common_exterior'],
          },
        },
        interiorCamera_1: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA_2',
            identifiers: ['common_exterior'],
          },
        },
        interiorCamera_2: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA_3',
            identifiers: ['common_exterior'],
          },
        },
      },
      usdzPathWithVariable: '',
    },
  },
};
